import omniRetailerContentConfigureService from 'src/store/modules/omni/omniRetailerContentScoreConfigure/reducers';

import * as omniRetailerContentConfigureOperation from './operation';
import * as omniRetailerContentConfigureType from './types';
import * as omniRetailerContentConfigureAction from './actions';

export { omniRetailerContentConfigureOperation, omniRetailerContentConfigureType, omniRetailerContentConfigureAction };

export default omniRetailerContentConfigureService;
